module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "layout-default",
    class: {
      "white-bg": _vm.whiteBg
    }
  }, [_c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.navMenuOutside),
      expression: "navMenuOutside"
    }],
    staticClass: "nav-menu-mobile",
    class: {
      show: _vm.showSideBarNav
    }
  }, [_vm._t("navMobile")], 2), _c('div', {
    staticClass: "header-main-wrapper"
  }, [_c('div', {
    staticClass: "header-main"
  }, [_c('div', {
    staticClass: "l-header"
  }, [(_vm.$slots.headerMenu) ? _c('Topline', {
    attrs: {
      "colorMain": _vm.menuMainColor
    }
  }, [_vm._t("top", null, {
    "slot": "line"
  }), _vm._t("headerMenu", null, {
    "slot": "addMenu"
  })], 2) : _vm._e(), _c('div', {
    staticClass: "header",
    class: {
      header_hide: _vm.isProfile
    }
  }, [_c('div', {
    staticClass: "header__item",
    class: _vm.headerHeigth
  }, [_c('div', {
    staticClass: "nav-menu-mobile-bar",
    on: {
      "click": _vm.menuToggle
    }
  }), _vm._t("header")], 2)]), (_vm.$slots.popup) ? _c('div', {
    staticClass: "popup"
  }, [_c('div', {
    staticClass: "inner"
  }, [_vm._t("popup")], 2)]) : _vm._e()], 1), _c('div', {
    staticClass: "wrapper",
    class: [_vm.wrapperPadding, {
      wrapper_show: _vm.isProfile
    }]
  }, [_c('div', {
    staticClass: "bg-wrapper",
    class: [{
      "bg-wrapper_padding": _vm.isProfile
    }, {
      "dark-bg": _vm.darkMenu
    }],
    style: (_vm.navWrapperStyle)
  }, [_c('markup-wrapper', [_vm._t("nav")], 2)], 1)])])]), _c('main', {
    staticClass: "content",
    class: {
      content_nopadding: _vm.isProfile
    }
  }, [_vm._t("default")], 2), _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer__content"
  }, [_c('markup-wrapper', [_c('footer-markup', {
    attrs: {
      "name": _vm.portalName,
      "logo": _vm.logoImage
    }
  }, [_vm._t("footer-alias", null, {
    "slot": "alias"
  }), _vm._t("footer-menu", null, {
    "slot": "menu"
  }), _vm._t("footer-info", null, {
    "slot": "info"
  }), _c('div', {
    attrs: {
      "slot": "phones"
    },
    slot: "phones"
  }, _vm._l((_vm.footerPhonesList), function(phone, index) {
    return _c('div', {
      key: index
    }, [(!!phone) ? _c('ext-phone', {
      attrs: {
        "phone": phone
      }
    }) : _vm._e()], 1)
  }), 0), _c('div', {
    attrs: {
      "slot": "emails"
    },
    slot: "emails"
  }, _vm._l((_vm.footerEmailsList), function(email, index) {
    return _c('div', {
      key: index
    }, [_c('footer-email', {
      attrs: {
        "value": email
      }
    })], 1)
  }), 0), _vm._t("counter", null, {
    "slot": "counter"
  }), _c('div', {
    staticClass: "social_networks-box",
    attrs: {
      "slot": "socialNetworks"
    },
    slot: "socialNetworks"
  }, [_c('a', {
    staticClass: "d-flex align-items-center",
    attrs: {
      "href": _vm.socialNetworks.telegram_url
    }
  }, [(_vm.socialNetworks.telegram_url) ? _c('AppSvgIcon', {
    staticClass: "ui_color__black me-2",
    attrs: {
      "manual-width": "35px",
      "manual-height": "35px",
      "color-mode": "fill",
      "template": _vm.$ui.IconSvgComponents.telegram
    }
  }) : _vm._e()], 1), _c('a', {
    staticClass: "d-flex align-items-center",
    attrs: {
      "href": _vm.socialNetworks.vk_url
    }
  }, [(_vm.socialNetworks.vk_url) ? _c('AppSvgIcon', {
    staticClass: "ui_color__black me-2",
    attrs: {
      "manual-width": "35px",
      "manual-height": "35px",
      "color-mode": "fill",
      "template": _vm.$ui.IconSvgComponents.vk
    }
  }) : _vm._e()], 1), _c('a', {
    staticClass: "d-flex align-items-center",
    attrs: {
      "href": _vm.socialNetworks.rutube_url
    }
  }, [(_vm.socialNetworks.rutube_url) ? _c('AppSvgIcon', {
    staticClass: "ui_color__black me-2",
    attrs: {
      "manual-width": "35px",
      "manual-height": "35px",
      "color-mode": "fill",
      "template": _vm.$ui.IconSvgComponents.rutube
    }
  }) : _vm._e()], 1), _c('a', {
    staticClass: "d-flex align-items-center",
    attrs: {
      "href": _vm.socialNetworks.dzen_url
    }
  }, [(_vm.socialNetworks.dzen_url) ? _c('AppSvgIcon', {
    staticClass: "ui_color__black me-2",
    attrs: {
      "manual-width": "35px",
      "manual-height": "35px",
      "color-mode": "fill",
      "template": _vm.$ui.IconSvgComponents.dzen
    }
  }) : _vm._e()], 1), _c('a', {
    staticClass: "d-flex align-items-center",
    attrs: {
      "href": _vm.socialNetworks.ok_url
    }
  }, [(_vm.socialNetworks.ok_url) ? _c('AppSvgIcon', {
    staticClass: "ui_color__black me-2",
    attrs: {
      "manual-width": "35px",
      "manual-height": "35px",
      "color-mode": "fill",
      "template": _vm.$ui.IconSvgComponents.odnoklassniki
    }
  }) : _vm._e()], 1)])], 2)], 1)], 1), (_vm.$slots.partners) ? _c('div', {
    staticClass: "footer__partners"
  }, [_c('markup-wrapper', [_vm._t("partners")], 2)], 1) : _vm._e(), (_vm.coordinatorsImages) ? _c('div', {
    staticClass: "footer__coordinators"
  }, [_c('CoordinatorsBox', {
    attrs: {
      "items": _vm.coordinatorsImages
    }
  })], 1) : _vm._e()]), (_vm.$slots.confirm || _vm.$slots.cookie) ? _c('div', {
    staticClass: "confirm"
  }, [_c('div', {
    staticClass: "confirm__wrapper"
  }, [_vm._t("cookie"), _vm._t("confirm")], 2)]) : _vm._e(), _c('scroll-top', {
    staticClass: "scroll-top"
  }), _c('div', {
    staticClass: "layout-default__hidden"
  }, [_vm._t("hidden")], 2), _vm._t("modal")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-457d2244","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/Default.vue
// module id = a70f5b527f7634c669d8
// module chunks = 0